import { defineComponent as _defineComponent } from 'vue'
import { NavigationResult } from '@/sdk'
import Input from './input.vue'
import { ref, watchEffect, computed, watch } from 'vue'
import { round } from '@/utils'
import {
  useSDK,
  customMap,
  RightMenuEum,
  customMouseMenuStack,
  useEmitLeave,
  useViewEdit,
  showInfoStack
} from '@/hook'
import { Loading } from '@kankan/components'
import { store } from '@/store'
import { UN_DE_RES } from '@/request'
import { router } from '@/router'
import { os } from '@/utils'
import {
  addCheckSupportPano,
  delCheckSupportPano
} from '@/views/sys/mode-tab/help'
import { ui18n } from '@/lang'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const sdk = useSDK()
const navigation = sdk.createNavigation()
const result = ref<NavigationResult>()
const err = ref<string>('')

navigation.bus.on('reposStartMarker', pos => {
  store.navigation[0].screen = pos
})
navigation.bus.on('reposEndMarker', pos => (store.navigation[1].screen = pos))

const time = computed(() => {
  if (result.value && result.value.dis) {
    let count = result.value.dis / 1.333
    let h = Math.floor(count / (60 * 60))
    let m = Math.floor((count - h * 60 * 60) / 60)
    let s = Math.ceil(count - h * 60 * 60 - m * 60)
    if (m > 0 && s > 0) {
      m++
      s = 0
    }
    return (
      (h ? `${h + ui18n.t('sys.time.h')}` : '') +
      (m ? `${m + ui18n.t('sys.time.m')}` : '') +
      (s ? `${s + ui18n.t('sys.time.s')}` : '')
    )
  }
})

const destory = () => {
  if (result.value || err.value) {
    navigation.destroy()
    result.value = err.value = null
  }
}

watchEffect(() => {
  try {
    err.value = ''
    const startArgs = store.navigation[0]
      ? ([
          store.navigation[0].pos.position,
          store.navigation[0].inMap,
          store.navigation[0].pos.datasetId
        ] as const)
      : ([null, null, null] as const)
    const endArgs = store.navigation[1]
      ? ([
          store.navigation[1].pos.position,
          store.navigation[1].inMap,
          store.navigation[1].pos.datasetId
        ] as const)
      : ([null, null, null] as const)

      // console.error(startArgs, endArgs, store.navigation[0])
    navigation.setStartPoint(...startArgs)
    navigation.setEndPoint(...endArgs)

    if (store.navigation[0] && store.navigation[1]) {
      Loading.show()
      navigation.generate().then(data => {
        Loading.hide()
        if ((data as UN_DE_RES).code) {
          err.value = ui18n.t('scene.navErr')
          // (data as UN_DE_RES).msg
          result.value = null
        } else {
          result.value = data as NavigationResult
        }
      })
    } else {
      destory()
    }
  } catch (e) {
    console.error(e)
  }

  // if (props.store.navigation[0] && props.store.navigation[1]) {
  //   result.value = {
  //     dis: 12,
  //     time: 300,
  //     steps: [
  //       {
  //         desc: '四维 1 号展厅 | 1楼',
  //         dis: 2
  //       },
  //       {
  //         desc: '步行楼梯至2楼',
  //         dis: 2
  //       },
  //       {
  //         desc: '步行楼梯至2楼',
  //         dis: 2
  //       },
  //       {
  //         desc: '四维时代 | 5楼',
  //         dis: 0
  //       }
  //     ]
  //   }
  // } else {
  //   result.value = null
  // }
})

const transform = () => {
  navigation.setStartPoint(null, null, null)
  navigation.setEndPoint(null, null, null)
  const start = store.navigation[1]
  const end = store.navigation[0]
  start && (start.screen = null)
  end && (end.screen = null)
  store.navigation[0] = start
  store.navigation[1] = end
}

const clear = (index: number) => {
  store.navigation[index] = null
}

const changeNavigation = (val, index) => {
  const sdk = useSDK()
  sdk.store.navigation[index] = val
}

useViewEdit(() => {
  showInfoStack.push(ref(null))
  customMouseMenuStack.push(
    ref(
      customMap.rMouseMenu.filter(
        item =>
          item.key === RightMenuEum.NavStart || item.key === RightMenuEum.NavEnd
      )
    )
  )

  const stopWatch = watch(
    router.currentRoute,
    () => {
      const params = router.currentRoute.value.params
      if (params && params.index) {
        sdk.store.navigation[Number(params.index)] = {
          pos: JSON.parse(params.pos as string),
          inMap: !!Number(params.inMap)
        }
      }
    },
    { immediate: true, deep: true }
  )

  const checkMode = () => {
    const poss = store.navigation
      .filter(item => item?.pos?.position)
      .map(item => item.pos.position)
    return !poss.length || sdk.scene.canShapeToPanoMode(poss)
  }
  addCheckSupportPano(checkMode)

  return () => {
    destory()
    stopWatch()
    customMouseMenuStack.pop()
    showInfoStack.pop()
    sdk.store.navigation.length = 0
    delCheckSupportPano(checkMode)
  }
})

const __returned__ = { sdk, navigation, result, err, time, destory, transform, clear, changeNavigation, Input, get round() { return round }, get useEmitLeave() { return useEmitLeave }, get store() { return store }, get os() { return os } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})